<div #canvas style="overflow-x: auto;" class="position-relative d-flex flex-column align-items-end gap-8">
    <button (click)="clearArea()" class="transparent-btn close gap-1">
        <i class="fa-regular fa-circle-xmark text-primary"></i>
        <h6 class="text-primary align-middle d-inline-block pl-1">Clear</h6>
    </button>
    <div class="card bg-gray-1">
        <canvas id="canvas" width="352" height="160"></canvas>
    </div>
</div>
